export function describeShell(network) {
    if (network === 'offline') {
        return { network, bannerMessageId: 'app.offline.banner', canRetry: true, canFetch: false };
    }
    return { network, canRetry: false, canFetch: true };
}
//# sourceMappingURL=connectivity.js.map